// 承載router-view的components
const Start = resolve => {
  import('components/start/start').then(module => {
    resolve(module);
  });
};

export default {
  path: '/train',
  redirect: '/train/query',
  component: Start,
  children: [
    {
      path: 'query',
      name: '火车票查询',
      component: resolve => require(['pages/train/query/query.vue'], resolve),
    },
    {
      // 火车票订单详情
      path: 'orderDetail',
      name: 'TrainOrderDetail',
      component: resolve => require(['pages/train/order/order-detail/order-detail.vue'], resolve)
    },
    {
      path: '*',
      redirect: '/home',
    },
  ]
}
